import IconNavbarTwitter from "./icon-navbar-twitter";

export default IconNavbarTwitter;